// src/router/index.js
import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/components/Login"; // 根据你的文件路径调整导入路径。使用@符号是Vue CLI的别名，指向src目录。
import Home from "@/components/Home";
// import ImagePagefrom '../views/ImagePage.vue';
import index from "@/views/index/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    component: index,
    meta: {
      requireAuth: false,
    },
    redirect: "/",
    children: [
      {
        path: "/",
        name: "home",
        meta: {
          requireAuth: false,
        },
        component: () =>
          import(/* webpackChunkName: "home" */ "@/views/home/home.vue"),
      },

      {
        path: "/news",
        name: "news",
        meta: {
          requireAuth: false,
        },
        component: () =>
          import(/* webpackChunkName: "news" */ "@/views/news/news.vue"),
      },
      {
        path: "/techService",
        name: "techService",
        meta: {
          requireAuth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "techService" */ "@/views/techService/index.vue"
          ),
      },
      {
        path: "/articleDetail",
        name: "articleDetail",
        meta: {
          requireAuth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "articleDetail" */ "@/views/articleDetail/index.vue"
          ),
      },
      {
        path: "/standard",
        name: "standard",
        meta: {
          requireAuth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "standard" */ "@/views/standard/index.vue"
          ),
      },
      {
        path: "/dataRemit",
        name: "dataRemit",
        meta: {
          requireAuth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "dataRemit" */ "@/views/dataRemit/index.vue"
          ),
      },
      {
        path: "/about",
        name: "about",
        meta: {
          requireAuth: false,
        },
        component: () =>
          import(/* webpackChunkName: "about" */ "@/views/about/index.vue"),
      },
      {
        path: "/help",
        name: "help",
        meta: {
          requireAuth: false,
        },
        component: () =>
          import(/* webpackChunkName: "help" */ "@/views/help/index.vue"),
      },
      {
        path: "/dataInfo",
        name: "dataInfo",
        meta: {
          requireAuth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "dataInfo" */ "@/views/dataInfo/index.vue"
          ),
      },
      {
        path: "/dataInfoList",
        name: "dataInfoList",
        meta: {
          requireAuth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "dataInfoList" */ "@/views/dataInfoList/index.vue"
          ),
      },
      {
        path: "/resourceResult",
        name: "resourceResult",
        meta: {
          requireAuth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "resourceResult" */ "@/views/resourceResult/resourceResult.vue"
          ),
      },
      {
        path: "/myIntention",
        name: "myIntention",
        meta: {
          requireAuth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "myIntention" */ "@/views/myIntention/index.vue"
          ),
      },
      {
        path: "/subject",
        name: "subject",
        meta: {
          requireAuth: false,
        },
        component: () =>
          import(/* webpackChunkName: "subject" */ "@/views/subject/index.vue"),
      },
      {
        path: "/subject/detail",
        name: "subjectDetail",
        meta: {
          requireAuth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "subjectDetail" */ "@/views/subject/detail.vue"
          ),
      },
      {
        path: "/articleSearch",
        name: "articleSearch",
        meta: {
          requireAuth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "articleSearch" */ "@/views/articleSearch/index.vue"
          ),
      },
      {
        path: "/geneDetail",
        name: "geneDetail",
        meta: {
          requireAuth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "geneDetail" */ "@/views/geneDetail/geneDetail.vue"
          ),
      },
      {
        path: "/compareDetail",
        name: "compareDetail",
        meta: {
          requireAuth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "compareDetail" */ "@/views/compareDetail/index.vue"
          ),
      },
      {
        path: "/login",
        name: "login",
        meta: {
          requireAuth: false,
        },
        component: () =>
          import(/* webpackChunkName: "login" */ "@/views/login/login.vue"),
      },
      {
        path: "/register",
        name: "register",
        meta: {
          requireAuth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "register" */ "@/views/register/register.vue"
          ),
      },
      {
        path: "/userCenter",
        name: "userCenter",
        meta: {
          requireAuth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "userCenter" */ "@/views/userCenter/userCenter.vue"
          ),
      },
      {
        path: "/resourceHome",
        name: "resourceHome",
        meta: {
          requireAuth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "resourceHome" */ "@/views/resourceHome/resourceHome.vue"
          ),
      },
      {
        path: "/changePwd",
        name: "changePwd",
        meta: {
          requireAuth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "changePwd" */ "@/views/changePwd/changePwd.vue"
          ),
      },
      {
        path: "/forgetPwd",
        name: "forgetPwd",
        meta: {
          requireAuth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "forgetPwd" */ "@/views/forgetPwd/forgetPwd.vue"
          ),
      },
    ],
  },

  {
    path: "*",
    name: "NotFound404",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/NotFound404/NotFound404.vue"
      ),
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const auth = require("@/router/auth").default; // 引入认证守卫
  auth.redirectIfNotAuthenticated(to, from, next);
});
export default router;
